import { render, staticRenderFns } from "./ClicRow.vue?vue&type=template&id=0b275649&"
import script from "./ClicRow.vue?vue&type=script&lang=js&"
export * from "./ClicRow.vue?vue&type=script&lang=js&"
import style0 from "./ClicRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports